export enum ProfileTab {
  data = 'data',
  passwordChange = 'passwordChange',
}
